/** @format */

import React, { useState, useEffect } from "react";
import { AlertTriangle } from "lucide-react";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import "../../css/ModalAnnouncement.css";

const API_URL = "https://api.traffy.in.th/greeting-api/status";

export default function ModalAnnouncement() {
  const [announcement, setAnnouncement] = useState(null);
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const testType = params.get("test_announcement");

    if (testType) {
      const mockData = {
        title: `ประกาศปิดปรับปรุงระบบ`,
        message: `จะไม่สามารถใช้งานได้ชั่วคราว ขออภัยในความไม่สะดวกครับ`,
        highlight_message: "ระหว่างวันที่ 14 พ.ย.68 23:00น. - 15 พ.ย.68 6:00น.",
        url: "https://www.traffy.in.th/2a7430d4aa7b805d9641d724f3052036",
        created_at: "2025-11-06 14:35:18.123+0700",
      };

      if (testType === "error") {
        const searchParams = new URLSearchParams(mockData);
        searchParams.append("is_test", "true");
        navigate(`/maintenance?${searchParams.toString()}`, { replace: true });
        return;
      } else if (testType === "warning") {
        setAnnouncement({ type: "warning", ...mockData });
        setShow(true);
        return;
      }
    }

    fetch(API_URL)
      .then((res) => {
        if (!res.ok) {
          console.error("API greeting error:", res.status, res.statusText);
          throw new Error(`HTTP ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        if (data.type === "error") {
          navigate("/maintenance", { replace: true });
        } else if (data.type === "warning") {
          setAnnouncement(data);
          setShow(true);
        }
      })
      .catch((err) => {
        console.error("API greeting error:", err);
      });
  }, [navigate]);

  const handleClose = () => {
    sessionStorage.setItem("announcementDismissed", "true");
    setShow(false);
  };

  if (!show || !announcement) return null;

  const isWarning = announcement.type === "warning";
  const dismissed = sessionStorage.getItem("announcementDismissed");
  if (isWarning && dismissed) return null;

  const { message, highlight_message } = announcement;
  const index =
    message && highlight_message ? message.indexOf(highlight_message) : -1;

  return (
    <div
      className="announcement-backdrop"
      style={{ fontFamily: "Noto Sans Thai" }}>
      <div className="announcement-modal">
        <div className="announcement-header announcement-header-warning">
          <AlertTriangle className="icon" size={28} color="#856404" />
          <h5 className="announcement-title">
            {announcement.title || "โปรดทราบ"}
          </h5>
        </div>
        <div className="announcement-body">
          {index > -1 ? (
            <p>
              {message.substring(0, index)}
              <strong className="highlight-text">{highlight_message}</strong>
              {message.substring(index + highlight_message.length)}
            </p>
          ) : (
            <p>{message}</p>
          )}
        </div>
        <div className="announcement-footer">
          {announcement.url && (
            <Button
              style={{ fontFamily: "Noto Sans Thai" }}
              variant="contained"
              color="secondary"
              sx={{ mr: 2 }}
              onClick={() => window.open(announcement.url, "_blank")}>
              ดูรายละเอียดเพิ่มเติม
            </Button>
          )}
          <Button
            variant="contained"
            color="primary"
            onClick={handleClose}
            style={{ fontFamily: "Noto Sans Thai" }}>
            ปิด
          </Button>
        </div>
      </div>
    </div>
  );
}
